import { GeneralState } from './types';

export const getGeneral = (state: any): GeneralState => state.general;
